
export default {
    namespaced: true,
    state: {
        rooms: [
            {
                name: "LIVE: Real Madrid vs Liverpool",
                streamUrl: "https://player.twitch.tv/?channel=hdpro66",
                thumbUrl: "https://janus2.reactoo.co.uk/1/1.jpg",
                roomId: "20161",
                roomName: 'Demo room'
            },
            {
                name: "A Sports match",
                streamUrl: "https://janus2.reactoo.co.uk/1/index.m3u8",
                thumbUrl: "https://janus2.reactoo.co.uk/1/1.jpg",
                roomId: "20181",
                roomName: 'Aser Media 2nd floor'
            },
            {
                name: "PPV event",
                streamUrl: "https://janus2.reactoo.co.uk/2/index.m3u8",
                thumbUrl: "https://janus2.reactoo.co.uk/2/2.jpg",
                roomId: "20182",
                roomName: 'Test room 2'
            },
            {
                name: "Brand event",
                streamUrl: "https://janus2.reactoo.co.uk/3/index.m3u8",
                thumbUrl: "https://janus2.reactoo.co.uk/3/3.jpg",
                roomId: "20183",
                roomName: 'Test room 3'
            },
            {
                name: "Movie trailer",
                streamUrl: "https://janus2.reactoo.co.uk/4/index.m3u8",
                thumbUrl: "https://janus2.reactoo.co.uk/4/4.jpg",
                roomId: "20184",
                roomName: 'Test room 4'
            },
            {
                name: "Live concert",
                streamUrl: "https://janus2.reactoo.co.uk/5/index.m3u8",
                thumbUrl: "https://janus2.reactoo.co.uk/5/5.jpg",
                roomId: "20185",
                roomName: 'Test room 5'
            },
            {
                name: "Sync test",
                thumbUrl: "https://i.stack.imgur.com/0laHY.jpg",
                streamUrl: "https://janus2.reactoo.co.uk/4/index.m3u8",
                roomId: "20192",
                roomName: 'Sync test'
            }
        ]
    },
    getters: {
        getRoomById: (state) => (id) => {
            return state.rooms.find(room => room.roomId === id);
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js